import { deleteCookie, readCookie, writeCookie } from "@bitcashier/shared/core/cookies.js";
import { VIEW_AS_ACTIVE_CLIENT_KEY, viewingAsUserId } from "./viewAsStore.js";

// Where the active client id — the X-Client-Id of every request — is kept.
//
// Normally that is the `active-client` cookie, which every tab shares. While a Super admin views the
// dashboard as another user it is this tab's sessionStorage instead: writing the target's client
// into the shared cookie would quietly repoint the admin's own dashboard tabs at it (a Super admin
// may open any client), so their next action there would land on that customer's account. Kept
// apart, the view starts from the target's own clients and leaving it finds the admin's selection
// untouched.

const COOKIE = "active-client";

export function readActiveClientId() {
  if (!viewingAsUserId()) return readCookie(COOKIE) || null;
  try {
    return sessionStorage.getItem(VIEW_AS_ACTIVE_CLIENT_KEY) || null;
  } catch {
    return null;
  }
}

export function writeActiveClientId(clientId) {
  if (!viewingAsUserId()) return writeCookie(COOKIE, clientId);
  try {
    sessionStorage.setItem(VIEW_AS_ACTIVE_CLIENT_KEY, clientId);
  } catch {
    /* storage unavailable: the client is picked again from the list on the next load */
  }
}

export function forgetActiveClientId() {
  if (!viewingAsUserId()) return deleteCookie(COOKIE);
  try {
    sessionStorage.removeItem(VIEW_AS_ACTIVE_CLIENT_KEY);
  } catch {
    /* nothing stored */
  }
}
